import PropType from 'prop-types';
import {useEffect, useState} from 'react';
import Spinner from 'components/Spinner';
import PlaceholderImage from 'images/no-image@2x.png';

export const DefaultImg = ({ src }) => (
    <img
        className="no-image"
        alt="Not Available"
        src={src}
        style={{
            width: '100%',
            height: 'auto',
            display: 'inline-block',
        }}
    />
);

export const Loader = () => <Spinner />;

const UnLoader = (props) => {
    const { defaultUnloader, getNoImagePlaceholder } = props;
    if (defaultUnloader) {
        return defaultUnloader;
    }
    return (<DefaultImg
        src={getNoImagePlaceholder()}
    />);
};

UnLoader.propTypes = {
    defaultUnloader: PropType.node,
    getNoImagePlaceholder: PropType.func,
};

const ImageLoader = (props) => {
    const { src, defaultUnloader, getNoImagePlaceholder = () => PlaceholderImage, ...rest } = props;
    const [imageSrc, setImageSrc] = useState(getNoImagePlaceholder());
    const [isLoading, setIsLoading] = useState(() => {
        const img = new Image();
        img.src = src;
        return !img.complete;
    });
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (!src) {
            setImageSrc(getNoImagePlaceholder());
            setIsLoading(false);
            setHasError(true);
            return;
        }
        setIsLoading(true);
        setHasError(false);
        const img = new Image();
        img.onload = () => {
            setImageSrc(src);
            setIsLoading(false);
            setHasError(false);
        };
        img.onerror = () => {
            setImageSrc(getNoImagePlaceholder());
            setIsLoading(false);
            setHasError(true);
        };
        img.src = src;
    }, [src]);

    return (
        <>
            {isLoading && <Loader />}
            {!hasError ? (
                <img
                    data-testid="image-loader-img"
                    src={imageSrc}
                    {...rest}
                    style={{ ...rest.style, display: isLoading ? 'none' : 'block' }}
                    alt="RP Suite Image"
                />
            ) : (
                <UnLoader
                    defaultUnloader={defaultUnloader}
                    getNoImagePlaceholder={getNoImagePlaceholder}
                />
            )}
        </>
    );
};

DefaultImg.propTypes = {
    src: PropType.string.isRequired,
};
ImageLoader.propTypes = {
    defaultUnloader: PropType.node,
    getNoImagePlaceholder: PropType.func,
    loader: PropType.node,
    unloader: PropType.string,
    src: PropType.string,
};

export default ImageLoader;
